import type theme from '#build/ui/accordion'
import type { DeepPartial } from '@nuxt/ui'

const accordion: DeepPartial<typeof theme> = {
  slots: {
    item: 'last:border-b-1 first:border-t-1',
    trigger: 'lg:py-[30px] py-5 w-full flex items-center relative',
    label: 'font-semibold text-base md:text-lg',
    body: 'prose text-base pb-5 lg:pb-[30px]',
  },
}

export default accordion
